import { useState, useEffect, useCallback } from 'react';
import api from '../../services/api';
import { ehInteiro } from '../../components/funcoes';

export const useImprimirPedido = (props) => {
  const idPedido = props.match.params.id;
  const [loading, setLoading] = useState(true);
  const [itensPedido, setItensPedido] = useState([]);
  const [pedido, setPedido] = useState(null);

  const parseOrderProductsData = (data) => {
    const parsedData = data?.map((curr_order, i) => {
      let montagens = JSON.parse(curr_order?.Montagem);

      const montagemAgrup = montagens?.reduce((acc, atual) => {
        if (!acc[atual?.idMontagem]) {
          return {
            ...acc,
            [atual.idMontagem]: {
              IdMontagem: atual.idMontagem,
              DescricaoMontagem: atual.DescricaoMontagem,
              produtos: [
                {
                  idProd: atual.IdProduto,
                  label: atual.label,
                  precoMontagem: atual.precoMontagem,
                  quantidade: atual.quantidade,
                },
              ],
            },
          };
        }

        const montagem = acc[atual.idMontagem];

        const produto = {
          idProd: atual.IdProduto,
          label: atual.label,
          precoMontagem: atual.precoMontagem,
          quantidade: atual.quantidade,
        };

        return {
          ...acc,
          [atual.idMontagem]: {
            ...montagem,
            produtos: [...montagem.produtos, produto],
          },
        };
      }, {});

      return {
        id: i,
        idProdutoMontagem: curr_order.IdProduto,
        descricao: curr_order.Descricao,
        composicao: curr_order.Composicao,
        unidade: curr_order.Unidade,
        preco: curr_order.Valor,
        tamanho: curr_order.Tamanho,
        obs: curr_order.Observacao,
        adicionais: JSON.parse(curr_order.Adicionais),
        quantidade: ehInteiro(curr_order.Quantidade),
        sabores: JSON.parse(curr_order.Sabores),
        montagem: Object.values(montagemAgrup),
        tipo: curr_order.TipoProduto,
        BordaDescricao: curr_order.BordaDescricao,
        BordaPreco: curr_order.BordaPreco,
      };
    });

    const orderned = parsedData.sort((a, b) => {
      return a.descricao < b.descricao ? -1 : a.descricao > b.descricao ? 1 : 0;
    });

    return orderned;
  };

  const getOrder = useCallback(async () => {
    try {
      const { data } = await api.get(`pedido/encontrar/${idPedido}`);
      setPedido(data);
    } catch (err) {
      console.log(err);
    }
  }, []);

  const getOrderProducts = useCallback(async () => {
    try {
      const { data } = await api.get(`pedido-produto/encontrar/${idPedido}`);

      const parsedData = parseOrderProductsData(data);

      setItensPedido(parsedData);
      document.getElementById('buttonPrint').style.display = 'none';
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  }, []);

  const imprimir = async () => {
    await new Promise((resolve) => {
      setTimeout(resolve, 1000);
    });
    document.getElementById('buttonPrint').style.display = 'none';
    window.print();
    document.getElementById('buttonPrint').style.display = 'block';
  };

  const calcOrderChange = () => {
    if (!pedido?.Troco) return 0;

    const troco =
      (parseFloat(pedido.Troco) || 0) -
      parseFloat(pedido.ValorTotal) -
      parseFloat(pedido.TaxaEntrega);

    return troco > 0 ? troco : 0;
  };

  useEffect(() => {
    getOrder();
    getOrderProducts();
  }, [getOrder, getOrderProducts]);

  return {
    loading,
    itensPedido,
    pedido,
    orderChange: calcOrderChange(),
    imprimir,
  };
};
